export const selectThemeStyle = state => state.theme.themeStyle;
